import React from "react";
import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

type BubbleProps = {
    open: boolean;
    children: React.ReactNode;
    sx?: any;
    pos: "right" | "left";
}

const BubbleStyles = styled(Paper)(() => ({
    position: "absolute",
    padding: "8px 12px",
    borderRadius: 8,
    color: "#fff",
    backgroundColor: "#fc6262",
    zIndex: 10,
    whiteSpace: "nowrap",

    "&::after": {
        content: '""',
        position: "absolute",
        top: -8,
        left: 20,
        borderLeft: "8px solid transparent",
        borderRight: "8px solid transparent",
        borderBottom: "8px solid #fc6262",
    },
}));

const Bubble = ({ open, children, sx, pos }: BubbleProps) => {
    if (!open) return null;

    return (
        <BubbleStyles sx={{ ...sx, "&::after": { right: pos === "right" ? 20 : "unset", left: pos === "left" ? 20 : "unset" } }}>
            {children}
        </BubbleStyles>
    );
};

export default Bubble;
